// 登录页：账号密码换 token
import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { errorText } from "../lib/api";
import { useAuth } from "../lib/auth";
import { LanguageSwitch } from "../components/LanguageSwitch";
import { InstallHint } from "../components/InstallHint";

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const from = (loc.state as { from?: string } | null)?.from ?? "/";
  if (user) return <Navigate to={from} replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-box">
      <div className="login-language"><LanguageSwitch /></div>
      <form className="card" onSubmit={submit}>
        <h1>CSP 任务后台</h1>
        <p className="muted">请用公司分配的账号登录</p>
        <label className="field">
          <span className="lbl">账号</span>
          <input name="username" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        </label>
        <label className="field">
          <span className="lbl">密码</span>
          <input name="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <div className="notice err">{error}</div>}
        <button className="btn btn-primary btn-big" style={{ width: "100%" }} disabled={busy || !username || !password}>
          {busy ? "登录中…" : "登录"}
        </button>
      </form>
      <InstallHint />
    </div>
  );
}
